var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-input",
    _vm._b(
      {
        ref: "input",
        style: { minWidth: _vm.minWidth + "px!important" },
        attrs: { type: "textarea", rows: _vm.rows },
        on: { blur: _vm.onBlur, input: _vm.handleInput },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      },
      "el-input",
      _vm.params.inputProps,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }